import { render, staticRenderFns } from "./inStorage.vue?vue&type=template&id=57fce24a&scoped=true"
import script from "./inStorage.vue?vue&type=script&lang=js"
export * from "./inStorage.vue?vue&type=script&lang=js"
import style0 from "./inStorage.vue?vue&type=style&index=0&id=57fce24a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fce24a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57fce24a')) {
      api.createRecord('57fce24a', component.options)
    } else {
      api.reload('57fce24a', component.options)
    }
    module.hot.accept("./inStorage.vue?vue&type=template&id=57fce24a&scoped=true", function () {
      api.rerender('57fce24a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wareHouse/inStorage.vue"
export default component.exports